"use strict";
// import {MDCDialog, MDCDialogFoundation, util} from '@material/dialog';
// don't really know how this loads in the browser
import {MDCDialog, MDCDialogFoundation, util} from "@material/dialog";
// import countup so can be converted to ES5
import {CountUp} from "../../public/assets/js/countUp.min.js";
import Glide from "../../public/assets/js/glide.min.js";

// require('countup');

/**
 * scripts.js
 * globals, for use in common and unique script documents
 * from http://stackoverflow.com/a/7048295
 **/
var sm = 768;
var lg = 1152;
site.breakSm = 768;
site.breakLg = 1480;
site.isMobile;
site.isDesktop;
site.isMassive;
site.isTransitioningToMobile = false;
site.isTransitioningToDesktop = false;
site.isTransitioningToMassive = false;

site.isShowingEverything = false;
site.isShowingMarkers = false;
site.isHidingLabels = false;

site.screenWidth = $(window).width();
site.screenHeight = $(window).height();
site.$body = $("body");
site.navbar = $("#navbar"); // logo switching for nav
site.$projectSliderWrapper = $(".project-slider-wrapper");
site.$announcementBar;
site.lockBody;
site.unlockBody;
site.googleMap; // global so can set zoom level on mobile
site.mapStyleControl = document.getElementById("style-selector-control");

site.$currentPhaseDots;

// site.$topperSlider = document.getElementById('topper-slider');
site.$topperSlider = $("#topper-slider");

site.colors = {
  red: "#DB5649",
  blue: "#0589bf",
  blueline: "#003da5",
  greenline: "#00843d",
  redline: "#da291c",
  orangeline: "#ed8b00",
  bus: "#ffc72c",
  lightgray: "#888b8c", // for concentric rings
};

/*
 * Vision popup for mobile
 **/
var visionPopup = {
  init: function () {
    let visionElement = document.getElementById("vision-mdc-dialog");
    if (visionElement) {
      var dialog = new MDCDialog(document.querySelector("#vision-mdc-dialog"));

      dialog.listen("MDCDialog:accept", function () {});

      dialog.listen("MDCDialog:cancel", function () {});

      // document.querySelector('#default-dialog-activation').addEventListener('click', function (evt) {
      $(".vision-image-wrapper").on("click", function (evt) {
        dialog.lastFocusedTarget = evt.target;

        // if didn't click on flag, otherwise should just scroll down to current phase section
        if (evt.target.nodeName == "IMG") {
          var newImage = $(evt.target).attr("src");
          $("#dialog-image").attr("src", newImage);
          dialog.show();
        }
      });

      $("#dialog-close").on("click", function (evt) {
        dialog.close();
      });
    }
  },
  deinit: function () {
    $(".vision-image-wrapper").off();
    $("#dialog-close").off();
  },
};

/**
 * resize functions
 **/
$(window).resize(function () {
  checkMobile();

  // if on a page with a map
  if (site.googleMap) {
    // if going to desktop size
    if (site.isTransitioningToMobile) {
      // hide markers
      map.clearMarkers();
      // hide T
      map.tMarker.setVisible(false);

      // show google stuff
      map.everything();
      // zoom out for mobile
      site.googleMap.setZoom(map.config.mobileZoomLevel);
    } else if (site.isTransitioningToDesktop) {
      // hide markers, etc.
      map.hideEverything();
      // show neighborhood labels
      map.showLabels();
      // show T
      // map.tMarker.setVisible();

      // if markers visible, update zoom
      if (site.isShowingMarkers) {
        // zoom for desktop
        site.googleMap.setZoom(map.config.secondaryZoomLevel);
      } else {
        // else zoom out b/c probably coming from mobile
        site.googleMap.setZoom(map.config.desktopZoomLevel);
      }
      // re-center
      site.googleMap.setCenter(map.config.locations.unionSquareZoomCenter);
    } else if (site.isTransitioningToMassive) {
      // if markers visible, zoom in a bit, 2018.05.17 fritz
      if (site.isShowingMarkers) {
        // zoom in some more
        site.googleMap.setZoom(map.config.massiveSecondaryZoomLevel);
      } else {
        site.googleMap.setZoom(map.config.massiveZoomLevel);
      }
      // re-center
      site.googleMap.setCenter(map.config.locations.massiveUnionSquareZoomCenter);
    }
  }

  // redo gallery if exists so height doesn't get funky
  if ($("#topper-section").length > 0) {
    // console.log('resize slick');
    // site.$gallerySlider.slick('resize');
    $(".slick-list").css("height", "auto");
  }
});

$(window).scroll(function () {});

/**
 * Check Mobile every time resize the browser
 * set mobile flag
 **/
function checkMobile() {
  site.screenWidth = $(window).width();
  // only do it if already not mobile or initial
  if (site.screenWidth < site.breakSm) {
    // set correct main top margin so lose huge gap in iOS between abs bottom 0 and 100vh
    if ($(".video-banner-wrapper").length > 0) {
      $(".overview-section").css("margin-top", site.screenHeight);
    }

    // set vision popup
    visionPopup.init();

    // only transition to desktop one time. Check by if coming from mobile
    if (!site.isMobile) site.isTransitioningToMobile = true;
    else site.isTransitioningToMobile = false;

    // set flags
    site.isMobile = true;
    site.isDesktop = false;
    site.isMassive = false;

    // only check if already mobile and bigger
  } else if (site.screenWidth >= site.breakSm && site.screenWidth < site.breakLg) {
    // reset from mobile
    $(".overview-section").css("margin-top", "100vh");

    // remove vision popup
    visionPopup.deinit();

    // only transition to desktop one time
    if (site.isMobile || site.isMassive) site.isTransitioningToDesktop = true;
    else site.isTransitioningToDesktop = false;

    // set flags
    site.isMobile = false;
    site.isDesktop = true;
    site.isMassive = false;
  } else if (site.screenWidth >= site.breakLg) {
    // if coming from desktop
    if (site.isDesktop) site.isTransitioningToMassive = true;
    else site.isTransitioningToMassive = false;

    // set flag
    site.isMobile = false;
    site.isDesktop = false;
    site.isMassive = true;
  }
}

checkMobile(); // initial

/**
 ** svg4everybody
 ** makes svgs work in ie, from https://github.com/jonathantneal/svg4everybody
 **/
svg4everybody();

/**
 * After all things load...
 **/
$(document).ready(function () {
  // /*****
  // * Global vars
  // *****/

  // /*********************
  //  * Sharing
  //  *********************/
  // var $shareLink = $('#share-link');
  // $shareLink.on('click', function() {
  //     site.$body.removeClass('menu-is-open vision-is-open');
  //     site.$body.addClass('share-is-open');
  // });

  /**
   * Safari iOS grid bug
   **/

  if (bowser.safari && bowser.version < 10.3 && typeof bowser.ios != "undefined") {
    // document.body.classList.add('browser-' + require('bowser').name)
    // site.$body.addClass('browser-' + bowser.name.toLowerCase() + '-v' + bowser.version.toLowerCase());
    site.$body.addClass("safari-ios-under-10-3");
    // alert('Safari iOS < 10.3');
  }

  // safari el capitan
  if (bowser.safari && bowser.version < 10) {
    // document.body.classList.add('browser-' + require('bowser').name)
    // site.$body.addClass('browser-' + bowser.name.toLowerCase() + '-v' + bowser.version.toLowerCase());
    site.$body.addClass("safari-under-10");
  }

  /**
   * IE 10 and 11 grid support
   * IE 10 and 11 do support grids, but won't use the CSS @supports feature query
   **/
  if (bowser.msie && (bowser.version == 10 || bowser.version == 11)) {
    // alert('Hello China');
    site.$body.addClass("ie-10-11");
  }

  if (bowser.msedge && bowser.version < 17) {
    site.$body.addClass("oldedge-less17");
  }

  // nth of class workaround with jquery for non-grid browsers
  $(".sm-grid-item:gt(4)").addClass("no-show-when-no-grid-mobile");

  /**
   * Nav
   **/
  var $hamburgerIcon = $("#hamburger-icon-wrapper");
  var $nav = $("#nav");
  $hamburgerIcon.on("click", function () {
    site.$body.addClass("nav-is-open");
    if (site.isMobile) {
      // site.lockBody();
    }
  });

  var $closeHamburgerIcon = $("#close-nav-icon-wrapper");
  $closeHamburgerIcon.add(".nav-item").on("click", function () {
    site.$body.removeClass("nav-is-open");
    // stopBodyScrolling(false);
    if (site.isMobile) {
      // site.unlockBody();
    }
  });

  // close nav if click logo on home page
  $("#logo a").on("click", function () {
    site.$body.removeClass("nav-is-open");
  });

  // close nav if click on nav
  $(".nav-item").on("click", function () {
    site.$body.removeClass("nav-is-open");
  });

  /**
   * Global scrolling controller
   * for current event slider and number counter activator
   **/

  // var controller = new ScrollMagic.Controller({
  var controller = new ScrollMagic.Controller({
    globalSceneOptions: {},
  });

  /**
   * Vision section
   **/
  // vision slider check, from https://stackoverflow.com/a/3713713
  if ($("#vision-slider").length > 0) {
    // after images loaded!
    $("#vision-section").imagesLoaded(function () {
      var $visionSlider = $(".vision-slider");

      // change mobile select when changed on mobile
      var $visionTopics = $(".vision-topics");

      // change mobile select when changed on mobile
      var $visionSelect = $("#vision-select");

      // get slide count
      if (site.isMobile) {
        var visionTopicCount = 4;
      } else {
        var visionTopicCount = 6;
      }

      // from https://stackoverflow.com/a/499413
      $visionSlider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        $visionSelect.children().eq(nextSlide).attr("selected", "selected"); // from https://stackoverflow.com/a/5075443

        // dropdown coloring
        // use index b/c background colors based on index and allows name changes
        document.body.classList.remove("vision-show-1", "vision-show-2", "vision-show-3", "vision-show-4", "vision-show-5");
        // add class to body so map marker labels can change color
        document.body.classList.add("vision-show-" + (nextSlide + 1));

        // if going from commercial to project, be sure to fade it!
        if (nextSlide == 0) {
          console.log("nextSlide is 0");
          var $visionFirst = $visionSlider.find(".vision-rendering").first().find(".vision-image-wrapper");
          $visionFirst.addClass("show-second-image");
        }

        // if going back to something with flags, show first one
        console.log("nextSlide", nextSlide);
        var $nextSlide = $visionSlider.find(".slick-track").children().eq(nextSlide);
        var $firstImageFlag = $nextSlide.find(".callout-wrapper").first();
        $firstImageFlag.addClass("show-flag");
      });

      // desktop vision
      $visionSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: $visionTopics,
        speed: 300,
        dots: false,
        cssEase: "linear",
        pauseOnHover: false,
        mobileFirst: true,
        fade: true,
        infinite: false,
        adaptiveHeight: false,
      });

      // vision nav
      $visionTopics.slick({
        slidesToShow: 6,
        slidesToScroll: 6,
        arrows: false,
        asNavFor: ".vision-slider",
        infinite: false,
        focusOnSelect: true,
        mobileFirst: true,
      });

      // start on correct slide depending on current page
      // var $initialSlide = 0;
      if (document.body.id == "work-page") {
        console.log("slick to to 2");
        $visionSlider.slick("slickGoTo", 2);
      } else if (document.body.id == "live-page") {
        $visionSlider.slick("slickGoTo", 3);
      } else if (document.body.id == "enjoy-page") {
        $visionSlider.slick("slickGoTo", 4);
      } else if (document.body.id == "property-page") {
        // get num slides
        let numSlides = $visionSlider.find(".vision-rendering");
        // go to last slide (ground floor) if on property page
        if (numSlides) {
          $visionSlider.slick("slickGoTo", numSlides.length);
        }
      }

      /**
       * allow links to vision topic
       **/
      // watch for links to vision clicked
      $('.js-hero-block-link[data-vision!=""]').on("click", function () {
        // notice
        // get vision topic
        var visionTopic = $(this).data("vision");
        var goToVisionSlide = 0;

        switch (visionTopic) {
          case "none":
            goToVisionSlide = 0;
            break;
          case "project":
            goToVisionSlide = 0;
            break;
          case "commercial":
            goToVisionSlide = 2;
            break;
          case "residential":
            goToVisionSlide = 3;
            break;
          case "public-open-space":
            goToVisionSlide = 4;
            break;
          case "discover":
            goToVisionSlide = 5;
            break;
        }
      });

      /**
       * Change first slide
       **/
      $("#vision-section").imagesLoaded(function () {
        var slideTransition = new ScrollMagic.Scene({
          triggerElement: "#vision-slider",
          triggerHook: 0.4,
        })
          // .addIndicators({name: 'slide transition'})
          // assign function, from https://github.com/janpaepke/ScrollMagic/issues/281#issuecomment-86939155
          .on("start", function (event) {
            // fade to second project slide if initially active
            var $visionFirst = $visionSlider.find(".vision-rendering").first().find(".vision-image-wrapper");
            $visionFirst.addClass("show-second-image");
          })
          .addTo(controller); // assign the scene to the controller
      });

      /*
       * Hide initial callout flag if hover something else
       */
      document.querySelectorAll(".vision-image-wrapper").forEach(function (visionImage, index, arr) {
        // get local flags
        var imageFlags = visionImage.querySelectorAll(".callout-wrapper");
        var firstImageFlag = visionImage.querySelector(".callout-wrapper");
        // for each callout flag in each rendering...
        imageFlags.forEach(function (imageFlag, flagindex, flagarr) {
          // add hover listener
          imageFlag.addEventListener("mouseenter", function (event) {
            // remove initial flag from any
            // firstImageFlag.querySelector('.callout-text-wrapper').classList.remove('show-flag');
            firstImageFlag.classList.remove("show-flag");
          });
        });
        // if any hovered, and initial flag still showing, hide initial flag
      });

      //- Mobile vision dropdown select
      $visionSelect.change(function () {
        var selectedIndex = $visionSelect.prop("selectedIndex");
        $visionSlider.slick("goTo", selectedIndex);

        // change body class to can change dropdown bg color
        // forked from map code to highlight markers
        var visionIndex = $(this).children(":selected").attr("data-index");

        // reset body classes
        // document.body.classList.remove('vision-show-combined', 'vision-show-commercial', 'vision-show-residential', 'vision-show-civic-space', 'vision-show-features');

        // use index b/c background colors based on index and allows name changes
        document.body.classList.remove("vision-show-1", "vision-show-2", "vision-show-3", "vision-show-4", "vision-show-5");
        // add class to body so map marker labels can change color
        document.body.classList.add("vision-show-" + visionIndex);
      });
    });
  }

  /**
   * Features section
   **/

  // other pages
  if ($("#topper-section").length > 0) {
    $("#topper-section").imagesLoaded(function () {
      // var $topperSlider = $('.topper-slider');

      // desktop vision
      site.$topperSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        // arrows: false,
        // asNavFor: '.vision-topics',
        appendArrows: "#topper-arrows",
        speed: 300,
        dots: false,
        cssEase: "linear",
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        mobileFirst: true,
        // swipe: true,
        fade: true,
        infinite: true,
        adaptiveHeight: true,
        prevArrow: '<svg viewBox="0 0 512 512" class="topper-arrow-icon"><use xlink:href="#left-arrow-2"></use></svg>',
        nextArrow: '<svg viewBox="0 0 512 512" class="topper-arrow-icon right-topper-arrow-icon"><use xlink:href="#left-arrow-2"></use></svg>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              // swipe: false,
              // adaptiveHeight: false
            },
          },
        ],
      });
    });
  }

  /*
   * viewport helper
   * from https://gomakethings.com/how-to-test-if-an-element-is-in-the-viewport-with-vanilla-javascript/
   */
  var isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
  };

  /**
   * Numbers section
   **/

  // if at least one numbers section on the page... (count by numbers-inner as each section name has to be unique)
  if ($("#numbers").length > 0) {
    // countUp.js setup
    var countUpSections = []; // hold all of the number counters

    /**
     * Init countUp instance
     * separately b/c may have to wait if in viewport initially
     **/
    var runCountUp = function (section) {
      // console.log('runCountUp');

      // hold local counters
      var countUps = [];

      // prep counters
      for (var i = 0; i < 5; i++) {
        var numberElement = section.querySelector("#number-" + i + "-number");
        var number = numberElement.dataset.number;
        var duration = numberElement.dataset.duration;
        var decimalPlaces = numberElement.dataset.decimalplaces;

        var countUp = new CountUp(numberElement, number, {
          duration: duration,
          decimalPlaces: decimalPlaces,
        });

        // do it!
        if (!countUp.error) {
          countUps.push({
            countUp: countUp,
            index: i,
          });
        } else {
          console.error(countUp.error);
        }

        // animate it!
        for (var j = 0; j < countUps.length; j++) {
          // start countup, and show unit when done
          countUps[j].countUp.start();
        }
      }

      // add to pile
      // countUpSections.push(countUps);
    };

    var numberSections = document.querySelectorAll(".numbers");

    // // for each numbers section
    // numberSections.forEach(function(section, index) {
    //     var trigger = section.querySelector('.numbers-counter-trigger');

    //     // activate if not initially visible (b/c sets numbers to 0 when activated)
    //     if(!isInViewport(trigger)) {
    //         runCountUp(section);
    //     }

    // });

    /*
     * fire counter
     * @param section is current section to fire!
     */

    var startCount = function (countUps) {
      console.log("startCount()");

      for (var j = 0; j < countUps.length; j++) {
        // start countup, and show unit when done
        countUps[j].countUp.start();
      }
    };

    // only activate trigger after all images loaded so no accidental misfires
    $("#vision-section").imagesLoaded(function () {
      // hide all numbers before start
      // $('.number-unit').addClass('hidden-number');

      // add new scene for if number is initially visible
      var firstNumberSection = document.querySelector(".numbers");
      // var firstNumberTrigger = firstNumberSection.querySelector('.numbers-counter-trigger');
      var firstNumberTrigger = document.getElementById("home-page");
      // animate when scroll into view
      var firstNumberScene = new ScrollMagic.Scene({
        triggerElement: firstNumberTrigger,
        triggerHook: "onLeave",
        offset: 5,
      })
        // assign function, from https://github.com/janpaepke/ScrollMagic/issues/281#issuecomment-86939155
        .on("start", function (event) {
          // only run on scroll down, or if in viewport initially from gomakethings
          // don't run if initially visible b/c sets to 0 and distracts from video
          // console.log('start firstNumberScene', event.scrollDirection, isInViewport(firstNumberSection));
          // if(event.scrollDirection == 'FORWARD' && isInViewport(firstNumberSection)) {
          if (event.scrollDirection == "FORWARD") {
            // console.log('firstNumberScene()');
            // console.log('FORWARD');
            runCountUp(firstNumberSection);
          }
        })
        // .addIndicators({name: 'firstNumber'})
        .addTo(controller); // assign the scene to the controller

      // add new scene for each number trigger
      numberSections.forEach(function (section, index) {
        var trigger = section.querySelector(".numbers-counter-trigger");

        // animate when scroll into view
        var smallerLogoScene = new ScrollMagic.Scene({
          triggerElement: trigger,
          triggerHook: "onEnter",
        })
          // assign function, from https://github.com/janpaepke/ScrollMagic/issues/281#issuecomment-86939155
          .on("start", function (event) {
            // console.log("starting");
            // only run on scroll down, or if in viewport initially from gomakethings
            // don't run if initially visible b/c sets to 0 and distracts from video
            if (event.scrollDirection == "FORWARD") {
              // console.log("FORWARD");
              runCountUp(section);
            }
          })
          .addTo(controller); // assign the scene to the controller
      });
    });

    /**
     * fire numbers if visible then scroll down a bit
     * from https://stackoverflow.com/a/25060054/4504073
     **/
    var aboveTheFoldNumbersAnimated = false;
    var firstNumberTrigger = document.querySelector(".numbers-counter-trigger");
    var runNumbers = function () {
      console.log("runNumbers()");
      console.log("countUpSections", countUpSections);
      // if not at very top
      if (window.pageYOffset < 50 && isInViewport(firstNumberTrigger)) {
        // finally activate countUp (wanted to prevent 0's from showing initially)
        // get first number section b/c visible
        var firstNumberSection = document.querySelector(".numbers");
        // initialize
        // runCountUp(firstNumberSection, 0);
        runCountUp(firstNumberSection);

        // run the numbers
        // startCount(countUpSections[0]);
        aboveTheFoldNumbersAnimated = true;
      } else {
        // don't keep trying b/c will run naturally later
        aboveTheFoldNumbersAnimated = true;
      }
    };
  }

  /**
   * Questions and Answers Ajax
   **/

  if ($("#questions-answers-section").length > 0) {
    var questionsAnswers = {
      config: {
        wrapper: $("#questions-answers-list"),
        url: "home/questions-answers.json",
      },

      /**
       * run these after each ajax call and replace
       **/
      init: function () {
        // get new month data
        $.getJSON(this.config.url)
          .done(function (json) {
            // set html from json
            questionsAnswers.config.wrapper.html(json.html);

            /*
             * Questions and Answers
             */
            // can't use mejs__player class because using <source /> inside?
            $(".question-video").mediaelementplayer({
              // Do not forget to put a final slash (/)
              pluginPath: "https://cdnjs.com/libraries/mediaelement/",
              // this will allow the CDN to use Flash without restrictions
              // (by default, this is set as `sameDomain`)
              shimScriptAccess: "always",
              // more configuration
              videoWidth: "100%",
              videoHeight: "100%",
              // hideVideoControlsOnLoad: true,
              // hideVideoControlsOnPause: true,
              // enableAutosize: true,
              startLanguage: "en",
              success: function (mediaElement, originalNode, instance) {},
            });
          })
          .fail(function (jqxhr, textStatus, error) {
            var err = textStatus + ", " + error;
            console.log("questions-answers.json request failed: " + err);
          });
      },
    };

    // init on call
    questionsAnswers.init();
  }

  /*
   ** Current Phase Slider
   **/
  var $currentPhaseImagesSlider = $("#current-phase-images-slider");
  var currentPhaseSpeed = [10000, 5000]; // slow and fast speeds for slideshow
  // var currentPhaseSpeed = [250, 250]; // slow and fast speeds for slideshow

  // allow a second html version of dots for mobile placement
  // from https://github.com/kenwheeler/slick/issues/974#issuecomment-250088735
  var activeClass = "slick-active",
    ariaAttribute = "aria-hidden";
  // var $currentPhaseDots;

  $currentPhaseImagesSlider
    .on("init", function (event, slick) {
      // get dots
      site.$currentPhaseNavMobile = $("#current-phase-nav-mobile");

      $(".slick-dots li:first-of-type").addClass(activeClass).attr(ariaAttribute, false);

      // start auto slide when enter viewport
      // autoslide turn on code inspired by https://stackoverflow.com/a/28046818/4504073
      // magic scroll trigger, https://github.com/janpaepke/ScrollMagic/issues/281#issuecomment-86939155

      var duration = $currentPhaseImagesSlider.height();

      var startCurrentSlider = new ScrollMagic.Scene({
        duration: duration,
        triggerElement: "#current-phase-section",
      })
        // init sidebar sticky CTA after scroll down so header has right height
        .on("start", function (event) {
          // if have been beyond slider or coming back up from false start...
          if (event.scrollDirection == "FORWARD") {
            $currentPhaseImagesSlider.slick("slickPlay");
            // else haven't made it down yet
          } else {
            $currentPhaseImagesSlider.slick("slickPause");
          }
        })
        .on("end", function (event) {
          // if going down...
          if (event.scrollDirection == "FORWARD") {
            // pause so in case came to page below Current Phase section, slider won't already start
            $currentPhaseImagesSlider.slick("slickPause");
            // else coming back up...
          } else {
            $currentPhaseImagesSlider.slick("slickPlay");
          }
        })
        // .setPin('#page-header', {pushFollowers: false}) // pins the element for the the scene's duration
        // .setClassToggle("body", "visible-header") // add class toggle for icon
        // .addIndicators()
        .addTo(controller); // assign the scene to the controller
    })
    .on("afterChange", function (event, slick, currentSlide) {
      // speed up autoslide if not on first slide
      if (currentSlide == 0) {
        console.log("slower slide speed");
        $currentPhaseImagesSlider.slick("slickSetOption", "autoplaySpeed", currentPhaseSpeed[0], true);
      } else {
        console.log("quicker slide speed");
        $currentPhaseImagesSlider.slick("slickSetOption", "autoplaySpeed", currentPhaseSpeed[1], true);
      }

      // add active to new
      // $( 'li', site.$currentPhaseDots ).eq( currentSlide ).addClass( activeClass ).attr( ariaAttribute, false );
      site.$currentPhaseNavMobile.children(".slick-dots").children("li").eq(currentSlide).addClass(activeClass).attr(ariaAttribute, false);
    });

  // main nav
  $currentPhaseImagesSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    speed: 300,
    dots: true,
    appendDots: ".current-phase-nav",
    cssEase: "linear",
    pauseOnHover: false,
    mobileFirst: true,
    focusOnSelect: false,
    infinite: true,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    // autoplay: false,
    // autoplaySpeed: 12000,
    autoplaySpeed: 10000,
    // autoplaySpeed: 250,
  });

  /**
   * News-events mobile
   **/
  var $newsEventsSection = $("#news-events-section");
  var $newsItems = $newsEventsSection.find(".news-event");

  // allow user to remove color bg when click a second time.
  $newsItems.on("click", function () {
    $(this).toggleClass("mobile-hover");
  });

  /**
   * Announcement Bar
   **/
  var $announcementClose = $(".announcement-wrapper #close-icon");
  // var $reservationsBox = $("#reservations-box");
  // var $closeReservations = $("#close-reservations");
  // site.$anchorLinks = $(".anchor-link");

  // hide when clicked
  $announcementClose.on("click", function () {
    // closeAnnouncement();
    console.log("close announcement");
    document.body.classList.add("close-announcement");
    document.body.classList.remove("show-announcement");
  });

  /**
   * Prevent background scroll on iOS
   * from https://stackoverflow.com/a/37715240/4504073
   **/
  var $docEl = $("html, body");
  // var $wrap = $('.page-header-wrapper');
  var scrollTop;

  site.lockBody = function () {
    if (window.pageYOffset) {
      scrollTop = window.pageYOffset;
    }

    $docEl.css({
      height: "100%",
      overflow: "hidden",
    });
  };

  site.unlockBody = function () {
    $docEl.css({
      height: "",
      overflow: "",
    });

    window.scrollTo(0, scrollTop);
    window.setTimeout(function () {
      scrollTop = null;
    }, 0);
  };

  /*****
   * more consistent Value Proposition mobile hover/click
   *****/
  if (document.getElementById("text-section")) {
    document.querySelectorAll(".text-content-item-target").forEach(function (elem, index, arr) {
      // listen for click on value prop
      elem.addEventListener("click", function (evt) {
        console.log("clicked a text box");
        // then reveal or hide text
        this.classList.toggle("show-text");
      });
    });
  }

  /*****
   * Property Gallery
   *****/
  if (document.getElementById("gallery-glide")) {
    let galleryPeekSpacer = document.getElementById("gallery-peek-spacer");
    let galleryPeekPx = galleryPeekSpacer.offsetWidth;

    let galleryGutterSpacer = document.getElementById("gallery-gutter-spacer");
    let galleryGutterPx = galleryGutterSpacer.offsetWidth;

    console.log(galleryPeekPx);
    console.log(galleryGutterPx);

    var galleryGlide = new Glide("#gallery-glide", {
      type: "carousel",
      // autoplay: 6000,
      gap: 0,
      hoverpause: false,

      // gap: document.getElementById('gallery-gutter-spacer').offsetWidth,
      // peek: document.getElementById('gallery-peek-spacer').offsetWidth,

      // breakpoint workarounds, from https://github.com/glidejs/glide/issues/178#issuecomment-379172427
      // these dont even work!!!
      // breakpoints: {
      //   1280: {
      //     gap: document.getElementById('gallery-gutter-spacer').offsetWidth,
      //     peek: document.getElementById('gallery-peek-spacer').offsetWidth
      //   },
      //   1920: {
      //     gap: document.getElementById('gallery-gutter-spacer').offsetWidth,
      //     peek: document.getElementById('gallery-peek-spacer').offsetWidth
      //   }
      // }
    });

    // if desktop, add peek
    if (!site.isMobile) {
      // // show last slide after first slide passes, just once during visit
      // let gallerySlideshowWrapper = document.getElementById('gallery-slideshow-wrapper');
      // galleryGlide.on('run.after', function() {
      //   // Handler logic ...
      //   gallerySlideshowWrapper.classList.remove('hide-last-slide');
      // });

      // add desktop peek
      galleryGlide.update({
        gap: galleryGutterPx,
        peek: {before: galleryPeekPx, after: galleryPeekPx},
      });
    }

    // // handle resizing for peek
    // // this doesn't seem to work as of July 2021
    // window.addEventListener('resize', function() {
    //   if(!site.isMobile) {
    //     console.log('gallery update');
    //     let galleryPeekPx = galleryPeekSpacer.offsetWidth;
    //     let galleryGutterPx = galleryGutterSpacer.offsetWidth;
    //     console.log(galleryPeekPx);
    //     console.log(galleryGutterPx);
    //     console.log('galleryGlide', galleryGlide);
    //     galleryGlide.update({
    //       gap: galleryGutterPx,
    //       peek: {before: galleryPeekPx, after: galleryPeekPx},
    //       autoplay: 1000
    //     })
    //   }
    // });

    galleryGlide.mount();
  }
});
